import { Range, Editor } from 'slate';
import { getTextAtRange } from './getTextAtRange.mjs';
import { isRangeWithinVoid } from './isRangeWithinVoid.mjs';
import { unhangRange } from '../utilities/range/unhangRange.mjs';
import { hasMark } from '../utilities/nodes/marks/hasMark.mjs';

function isMarkActive(editor, type, at = editor.selection) {
  if (!at) {
    return false;
  }
  try {
    if (Range.isCollapsed(at) && !isRangeWithinVoid(editor, at)) {
      const marks = Editor.marks(editor);
      return marks ? marks[type] === true : false;
    }
    const range = unhangRange(editor, at);
    const textNodes = getTextAtRange(editor, range);
    return !textNodes.some(([node]) => !hasMark(node, type));
  } catch {
    // This query can throw if the document is not finished being normalized
    // during multi-pass normalization, for more details, refer to:
    // https://github.com/ianstormtaylor/slate/blob/main/docs/concepts/11-normalizing.md#multi-pass-normalizing
    return false;
  }
}

export { isMarkActive };
